import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const StyledImg = styled.div<{ s?: CSSProperties; src?: string }>(
  ({ s, src }) => ({
    backgroundImage: `url("${src || ''}")`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    margin: '0 auto',
    height: `${s?.maxHeight || '9.5'}rem`,
    width: `${s?.maxWidth || '9.5'}rem`,
    padding: 0,
    ...s,
  }),
);

export interface ImageProps {
  s?: CSSProperties;
  src?: string;
}

function ProductImage({ s, src }: ImageProps) {
  if (!src || typeof src !== 'string') return null;
  return <StyledImg aria-label="product" role="img" s={s} src={src} />;
}

export default ProductImage;
